import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Images } from '../models/placeholder.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CrudService {
  
  constructor(private http: HttpClient) { }

  getFotos(): Observable<Images> {
    return this.http.get<Images>('https://jsonplaceholder.typicode.com/photos');
  }
}



 